import {takeLatest} from "redux-saga/effects";
import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {getDetailsSouscriptionsSaga} from "./detailsSouscriptionSaga";

export default function* detailsSouscriptionsWatcher() {
  yield takeLatest(
    ActionsTypes.GET_DETAILS_SOUSCRIPTIONS,
    getDetailsSouscriptionsSaga
  );
}
